import * as React from "react";
import { createTheme, ThemeProvider } from "@mui/material";
import { BrowserRouter as Router } from "react-router-dom";

import ResponsiveMenuBar from "./Components/ResponsiveMenuBar";
import ScrollToTopOnNavigate from "./Components/ScrollToTopOnNavigate";
import DeferredShoutboxMount from "./Components/DeferredShoutboxMount";
import Footer from "./Components/Footer";
import PageRouteFallback from "./Components/PageRouteFallback";
import AuthProvider from "./contexts/AuthContext";
import DeferredNavigationProvider from "./contexts/DeferredNavigationContext";
import { SiteAnalyticsListener } from "./hooks/useSiteAnalytics";
import SocketProvider from "./contexts/SocketContext";
import AppRoutes from "./routes/AppRoutes";
import { getMainDeferClassName } from "./utils/clientRenderMode";

const theme = createTheme({
  palette: {
    header: {
      main: "#215c9c",
    },
  },
});

function ThemedAppShell() {
  const mainDeferClass = getMainDeferClassName();

  return (
    <>
      <SiteAnalyticsListener />
      <ScrollToTopOnNavigate />
      <ResponsiveMenuBar />
      <main id="mcverse-main" className={mainDeferClass || undefined}>
        <React.Suspense fallback={<PageRouteFallback />}>
          <AppRoutes />
        </React.Suspense>
      </main>
      <DeferredShoutboxMount />
      <Footer />
    </>
  );
}

export default function ThemedApp() {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <AuthProvider>
          <SocketProvider>
            <DeferredNavigationProvider>
              <ThemedAppShell />
            </DeferredNavigationProvider>
          </SocketProvider>
        </AuthProvider>
      </Router>
    </ThemeProvider>
  );
}
